import { Navigate, Outlet } from 'react-router-dom';
import ManaLayout from '../layout/Mana';
import { RouterWithMeta } from '@/router/index';
import React from 'react';
import LazyWrapper from '@/common/LasyWrapper';

const School = React.lazy(() => import('./pages/dictionary/school/School'));
const Teacher = React.lazy(() => import('@/pages/mana/pages/user/teacher/Teacher'));
const Research = React.lazy(() => import('./pages/user/research/Research'));
const Admin = React.lazy(() => import('./pages/user/admin/Admin'));

export const manaRouter: RouterWithMeta[] = [
  // 用户管理
  {
    path: 'user',
    element: <Navigate to="teacher" />,
    meta: {
      isRedirect: true
    }
  },
  {
    path: 'user',
    element: <Outlet />,
    children: [
      {
        path: 'teacher',
        element: <LazyWrapper><Teacher></Teacher></LazyWrapper>,
        meta: {
          name: '教师管理'
        }
      },
      {
        path: 'research',
        element: <LazyWrapper><Research></Research></LazyWrapper>,
        meta: {
          name: '教研室人员管理'
        }
      },
      {
        path: 'backstage',
        element: <LazyWrapper><Admin></Admin></LazyWrapper>,
        meta: {
          name: '后台人员管理'
        }
      }
    ],
    meta: {
      name: '用户管理',
      icon: 'icon-yonghuguanli'
    }
  },
  // 字典表管理
  {
    path: 'dictionary',
    meta: {
      name: '字典表管理',
      icon: 'icon-zidianbiaoguanli'
    },
    children: [
      {
        path: 'school',
        element: <LazyWrapper><School></School></LazyWrapper>,
        meta: {
          name: '学校管理'
        }
      },
      {
        path: 'course',
        meta: {
          name: '课程管理'
        }
      }
    ]
  },
  // 生学年管理
  {
    path: 'upgrade',
    meta: {
      name: '升学年管理',
      icon: 'icon-shengxuenian'
    }
  },
  // 用户登录情况
  {
    path: 'loginstatus',
    meta: {
      name: ' 用户登录情况',
      icon: 'icon-yonghudengluqingkuang'
    }
  },
  {
    path: 'reportandadvice',
    meta: {
      name: '投诉与建议',
      icon: 'icon-tousuyujianyi'
    }
  }
];

const manaRouterLayout: RouterWithMeta[] = [
  {
    path: 'mana',
    element: <Navigate to='user'></Navigate>
  },
  {
    path: 'mana',
    element: <ManaLayout />,
    children: manaRouter
  }
];
export default manaRouterLayout;